import styled from 'styled-components'

export const TagsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
`
